/**
 * ChatForge durable user memory (threads) — Hugging Face Xet bucket.
 *
 *   hf sync ./data hf://buckets/copperscout1/Chatforge
 *
 * Local mirror: chatforge/data/
 * Live chats also POST to origin, which writes the same bucket.
 */

export const CHATFORGE_HF_BUCKET = "copperscout1/Chatforge";
export const CHATFORGE_HF_BUCKET_URI = `hf://buckets/${CHATFORGE_HF_BUCKET}`;

export const CHATFORGE_DATA_SHELVES = ["user", "meta"] as const;

export function chatforgeBucketSyncPushCmd(localDir = "./data"): string {
  return `hf sync ${localDir} ${CHATFORGE_HF_BUCKET_URI}`;
}

export function chatforgeBucketSyncPullCmd(localDir = "./data"): string {
  return `hf sync ${CHATFORGE_HF_BUCKET_URI} ${localDir}`;
}
